<template>
  <div class="pa-2" v-if="!courseMarkConfigData">Lớp học này chưa được thiết lập cấu hình điểm</div>
  <div v-else>
    <div class="d-flex justify-content-between align-center">
      <div class="flex-fill">
        <MarkBreadcrumb></MarkBreadcrumb>
      </div>
      <v-progress-circular
        color="primary"
        size="24"
        indeterminate
        v-if="recalculatingAll"
      ></v-progress-circular>
      <v-menu v-else-if="canEdit || canUnLock">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" class="mr-2">mdi-settings</v-icon>
        </template>
        <v-list class="px-2" dense>
          <!-- <v-list-item class="py-1" @click="setShowLearningResult(!showLearningResult)">
            <v-list-item-icon class="mr-2"
              ><v-icon left
                >mdi-{{ showLearningResult ? 'eye-off' : 'eye' }}</v-icon
              ></v-list-item-icon
            >
            <v-list-item-content>{{
              showLearningResult ? 'Ẩn kết quả học tập' : 'Hiện kết quả học tập'
            }}</v-list-item-content>
          </v-list-item> -->
          <v-list-item class="py-1" @click="updateLock(true)" v-if="canLock">
            <v-list-item-icon class="mr-2">
              <v-icon left>mdi-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Khóa bảng điểm</v-list-item-content>
          </v-list-item>
          <v-list-item class="py-1" @click="updateLock(false)" v-if="canUnLock">
            <v-list-item-icon class="mr-2">
              <v-icon left>mdi-lock-open</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Mở khóa bảng điểm</v-list-item-content>
          </v-list-item>
          <v-list-item class="py-1" @click="onClickExport" v-if="canEdit">
            <v-list-item-icon class="mr-2">
              <v-icon left>mdi-file-excel</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Xuất file Excel</v-list-item-content>
          </v-list-item>
          <v-list-item class="py-1" @click="onClickRecalculateAll" v-if="canEdit">
            <v-list-item-icon class="mr-2">
              <v-icon left>mdi-calculator</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Tính lại toàn bộ bảng điểm</v-list-item-content>
          </v-list-item>
          <v-list-item class="py-1" @click="clearAllData" v-if="canDeleteAllData">
            <v-list-item-icon class="mr-2">
              <v-icon color="error" left>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Xóa toàn bộ dữ liệu</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- <v-switch small v-model="showLearningResult" class="text-body-2 mt-0" hide-details="auto">
        <template v-slot:label>
          <span class="text-body-2 text-sm-body-1">
            <span v-if="$vuetify.breakpoint.mobile">KQHT</span>
            <span v-else> Hiện kết quả học tập </span>
          </span>
        </template>
      </v-switch> -->
    </div>
    <!-- <v-tabs-items v-model="tab"> -->
    <!-- <v-tab-item key="mark-table"> -->
    <template>
      <v-data-table
        :class="{ editable: canEdit }"
        :dense="true"
        item-key="id"
        :show-select="canEdit"
        v-model="selected"
        disableSort
        v-if="classData"
        :headers="getHeaders"
        :items="tableData"
        item-class="row-class"
        hide-default-footer
        hide-default-header
        :disable-pagination="true"
        :mobile-breakpoint="0"
      >
        <template v-slot:top="">
          <div class="d-flex align-center align-sm-center w-100 py-2">
            <div
              class="text-body-2 pl-3 blue--text font-weight-bold py-0 py-sm-2"
              v-if="!!selected.length"
            >
              {{ selectedString }}
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex flex-md-row flex-column align-start align-md-center">
              <template v-if="!!selected.length">
                <!--                <v-btn
                  flat
                  text
                  color="primary"
                  small
                  @click="calculateLearningResultForSelected(true)"
                >
                  <v-icon class="mr-2">mdi-calculator</v-icon>
                  <span>Tính điểm TBTP</span>
                </v-btn>
                <v-btn
                  flat
                  text
                  color="primary"
                  small
                  @click="calculateLearningResultForSelected()"
                >
                  <v-icon class="mr-2">mdi-calculator</v-icon>
                  <span>Tính KQHT</span>
                </v-btn>
                -->
                <!-- <v-btn flat text color="primary" small @click="saveLearningResultForSelected">
                  <v-icon class="mr-2">mdi-content-save</v-icon>
                  <span>Lưu KQHT</span>
                </v-btn> -->
                <v-btn flat text color="error" small @click="removeLearningResultForSelected">
                  <v-icon class="mr-2">mdi-delete</v-icon>
                  <span>Xóa KQHT</span>
                </v-btn>
              </template>
            </div>
          </div>
        </template>

        <template v-slot:header="{ props, on }">
          <thead class="v-data-table-header">
            <tr>
              <th :rowspan="2" v-if="canEdit">
                <v-simple-checkbox
                  :value="!!props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>
              </th>
              <th
                v-for="(cell, index) in headers.filter(
                  header =>
                    !header.value.includes('learningResult') &&
                    header.value !== 'actions' &&
                    header.value !== 'retestMark'
                )"
                :key="cell.value"
                :rowspan="2"
              >
                <v-tooltip top v-if="cell.id">
                  <template v-slot:activator="{ on, attrs }">
                    <p
                      v-bind="attrs"
                      v-on="on"
                      v-if="cell.multiplier"
                      class="py-1 mb-0 text-center"
                    >
                      {{ cell.text }}
                      <span class="ml-1" v-if="cell.multiplier > 1"> ({{ cell.multiplier }})</span>
                    </p>
                  </template>
                  <div>
                    <p class="mb-0">
                      {{ cell.type === 'final' ? 'Điểm cuối môn' : 'Điểm thành phần' }}
                    </p>
                    <p class="mb-0">Hệ số điểm {{ cell.multiplier }}</p>
                  </div>
                </v-tooltip>
                <p v-else class="py-1 mb-0">
                  {{ cell.text }}
                </p>
                <v-btn
                  v-if="cell.id && canEdit"
                  icon
                  :title="
                    cell.type == 'final'
                      ? 'Điểm cuối môn được tính tự động từ các phiếu điểm'
                      : 'Sửa điểm'
                  "
                  class="d-block ma-auto"
                  @click.stop="cell.type == 'final' ? undefined : onClickEditMark(cell.id)"
                >
                  <v-icon small>
                    {{ cell.type == 'final' ? 'mdi-information' : 'mdi-pencil' }}
                  </v-icon>
                </v-btn>
                <!-- <template v-else>
                <v-simple-checkbox
                  :value="!!props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>
              </template> -->
              </th>
              <!-- v-if="showLearningResult" -->
              <th v-if="finalCourseMark" :rowspan="2">
                <p class="py-1 mb-0 text-center">
                  Điểm thi lại
                  <span class="ml-1" v-if="finalCourseMark.multiplier > 1">
                    ({{ finalCourseMark.multiplier }})</span
                  >
                </p>
              </th>
              <th
                colspan="6"
                class="text-center learning-result-cell"
                style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"
              >
                Kết quả học tập
              </th>
              <th class="text-center" :rowspan="2" v-if="canEdit">Hành động</th>
            </tr>
            <tr>
              <th
                class="text-center learning-result-cell"
                v-for="(cell, index) in props.headers.filter(header =>
                  header.value.includes('learningResult')
                )"
                :key="cell.value"
              >
                <template>
                  {{ cell.text }}
                </template>
              </th>
            </tr>
          </thead>
        </template>
        <!-- <template v-slot:item.data-table-select="{ select, isSelected }">
        <td>
          <v-checkbox :checked="isSelected" @change="select"></v-checkbox>
        </td>
      </template> -->
        <!-- <template v-slot:header.data-table-select="{ props, on }">
        <v-checkbox :checked="isSelected" @change="select"></v-checkbox>
      </template> -->
        <template v-slot:item.index="{ item }">
          {{ item.index + 1 }}
        </template>
        <template v-slot:item.learningResult.note="{ item }">
          <template
            v-if="
              (!shouldCheckCourseQualification || studentCourseQualificationStatus[item.id]) &&
              item.learningResult.id
            "
          >
            <v-btn icon v-if="canEdit && !item.learningResult.note" @click="onClickEditNote(item)">
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>
            <p
              text
              v-else
              class="mb-0 text-truncate student-note"
              @click="canEdit ? onClickEditNote(item) : undefined"
            >
              {{ item.learningResult.note }}
            </p>
          </template>
        </template>
        <template v-slot:item.learningResult.rank="{ item }">
          {{
            item.learningResult.rank === 'excellent'
              ? 'Xuất sắc'
              : item.learningResult.rank === 'very_good'
              ? 'Giỏi'
              : item.learningResult.rank === 'good'
              ? 'Khá'
              : item.learningResult.rank === 'normal'
              ? 'Trung bình'
              : item.learningResult.rank === 'bad'
              ? 'Yếu'
              : ''
          }}
        </template>
        <template v-slot:item.learningResult.qualifyForFinalExam="{ item }">
          <span class="success--text" v-if="item.learningResult.qualifyForFinalExam"> ✓ </span>
          <span class="error--text" v-else-if="item.learningResult.qualifyForFinalExam === false">
            ✖
          </span>
        </template>
        <template v-slot:item.learningResult.status="{ item }">
          {{
            item.learningResult.status === 'learn_again'
              ? 'Học lại'
              : item.learningResult.status === 'test_again'
              ? 'Thi lại'
              : item.learningResult.status === 'pass'
              ? 'Qua môn'
              : ''
          }}
        </template>
        <template v-slot:item.absentPercentage="{ item }">
          {{ item.absentPercentage + ' %' }}</template
        >
        <template v-slot:item.student="{ item }">
          <user-item
            :size="$vuetify.breakpoint.mobile ? 24 : undefined"
            :data="item.student"
            :to="'student/' + item.student.id"
          ></user-item>
        </template>
        <template v-slot:item.qualification="{ item }" v-if="canEdit">
          <v-simple-checkbox
            :value="studentCourseQualificationStatus[item.id]"
            @input="onQualificationChange($event, item)"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.drive_fulfilled="{ item }" v-if="canEdit">
          <v-simple-checkbox
            :value="studentDriveFulfillStatus[item.id]"
            @input="onFulfillStatusChange($event, item)"
          ></v-simple-checkbox>
        </template>
        <template v-slot:[`item.marksObj.${finalCourseMarkId}`]="{ item }" v-if="canEdit">
          <div class="d-flex align-center justify-center">
            {{ renderTextForFinalMark(item) }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }" v-if="canEdit">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="!shouldCheckCourseQualification || studentCourseQualificationStatus[item.id]"
                class="py-1"
                @click.stop="removeLearningResult(item)"
                icon
                color="error"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn></template
            >
            Xóa KQHT</v-tooltip
          >

          <!-- <v-menu v-if="!shouldCheckCourseQualification || studentCourseQualificationStatus[item.id]">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" icon small>
                <v-icon small>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list class="px-2" dense>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    class="py-1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="calculateLearningResult(item, true)"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-calculator</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Tính điểm TBTP </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                Điểm bỏ trống sẽ tính là 0
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    class="py-1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="calculateLearningResult(item)"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-calculator</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Tính KQHT </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                Điểm bỏ trống sẽ tính là 0
              </v-tooltip> -->
          <!-- <v-list-item class="py-1" @click.stop="saveLearningResult(item)">
                <v-list-item-icon>
                  <v-icon>mdi-content-save</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Lưu KQHT </v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->
          <!-- v-if="item.learningResult.id" -->
          <!-- <v-list-item
                v-if="item.learningResult.id"
                class="py-1"
                @click.stop="removeLearningResult(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Xóa kết quả học tập </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu> -->
        </template>
        <!-- <template v-slot:item.total="{ item }">
        <b class="subtitle-1 font-weight-bold">{{ item.total }}</b>
      </template> -->
      </v-data-table>
      <BaseTableSkeletonLoader v-else></BaseTableSkeletonLoader>
    </template>
    <!-- </v-tab-item> -->
    <!-- <v-tab-item key="final-mark-grading">
        <template>
          <BaseTableSkeletonLoader></BaseTableSkeletonLoader>
        </template>
      </v-tab-item>
    </v-tabs-items> -->

    <mark-edit-dialog
      v-if="dialog"
      :dialog="dialog"
      :markId="markId"
      @close="dialog = false"
      @save="onSaveMark"
    ></mark-edit-dialog>
    <note-dialog
      v-if="noteDialog"
      :dialog="noteDialog"
      :student="studentToNote"
      @close="closeNoteDialog"
      @save="saveNote"
    ></note-dialog>
    <BaseDialog
      v-if="exportDialog.isOpen"
      :isOpen="exportDialog.isOpen"
      :title="exportDialog.title"
      @close="exportDialog.isOpen = false"
      @cancel="exportDialog.onCancel"
      @confirm="exportDialog.callback"
      primaryText="Export"
    >
      <v-form lazy-validation ref="exportDialog">
        <v-card-text>
          <v-switch v-model="exportDialog.data.exportAllStudents">
            <template v-slot:label>
              <span>Xuất dữ liệu cho toàn bộ HV (bao gồm HV không đủ điều kiện tham gia)</span>
            </template>
          </v-switch>
          <v-switch v-model="exportDialog.data.exportLearningResult">
            <template v-slot:label> <span>Xuất dữ kết quả học tập</span> </template>
          </v-switch>
        </v-card-text>
      </v-form>
    </BaseDialog>
  </div>
</template>

<script>
import moment from 'moment'
import { saveAs } from 'file-saver'
import XLSX from 'xlsx'
import BaseDialog from '@/components/base/BaseDialog'
import { mapGetters, mapState, mapActions } from 'vuex'
import { Mark, Class } from '@/plugins/api'
import { calculateAbsentPercentage } from '@/helpers'
import UserItem from '@/modules/user/UserItem'
import MarkEditDialog from '@/modules/class/marks/MarkEditDialog'
import BaseTableSkeletonLoader from '@/components/base/BaseTableSkeletonLoader'
import NoteDialog from '@/modules/class/marks/NoteDialog'
import _ from 'lodash'
import { round } from 'number-precision'
import MarkBreadcrumb from '@/modules/class/marks/MarkBreadcrumb'

export default {
  components: {
    MarkBreadcrumb,
    BaseDialog,
    UserItem,
    MarkEditDialog,
    NoteDialog,
    BaseTableSkeletonLoader
  },
  created() {
    this.genTableData()
  },
  watch: {
    students() {
      this.genTableData()
    },
    marks() {
      this.genTableData()
    },
    learningResults() {
      this.genTableData()
    }
  },
  data() {
    return {
      recalculatingAll: false,
      // showLearningResult: localStorage.getItem('showLearningResult') === 'true',
      tabs: [
        { text: 'Sổ điểm', value: 'mark-table' },
        { text: 'Chấm điểm cuối môn', value: 'final-mark-grading' }
      ],
      tab: 'mark-table',
      studentToNote: null,
      dialog: false,
      noteDialog: false,
      markDialog: false,
      markId: null,
      tableData: [],
      selected: [],
      exportDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.exportDialog.isOpen = false
        },
        callback: () => {}
      }
    }
  },

  computed: {
    ...mapGetters('classDetail', ['students', 'finalCourseMark']),
    ...mapGetters('auth', ['user']),
    ...mapGetters('classDetail', ['classData']),
    ...mapState('classDetail', [
      'marks',
      'learningResults',
      'slots',
      'attendances',
      'retestMarks',
      'courseMarkConfigData'
    ]),
    ...mapState('auth', ['user', 'role']),
    selectedString() {
      if (!this.tableData) {
        return ''
      }
      const realSelectedCount = this.tableData
        .filter(i => this.selected.find(f => f.student.id === i.student.id))
        .filter(
          i => !this.shouldCheckCourseQualification || this.studentCourseQualificationStatus[i.id]
        ).length

      return `Đã chọn ${realSelectedCount} học viên`
    },

    // shouldDisableBulkCalculateComponentAverage() {
    //   if (!this.tableData) {
    //     return true
    //   }
    //   if (!this.finalCourseMarkId) {
    //     return true
    //   }
    //   const realSelected = this.tableData
    //     .filter(i => this.selected.find(f => f.student.id === i.student.id))
    //     .filter(
    //       i => !this.shouldCheckCourseQualification || this.studentCourseQualificationStatus[i.id]
    //     )

    //   return !realSelected.some(({ marksObj }) => {
    //     return Object.entries(marksObj).some(([k, v]) => {
    //       return k !== this.finalCourseMarkId && v !== undefined && v !== null
    //     })
    //   })
    // },
    // shouldDisableBulkCalculateLearningResult() {
    //   if (!this.tableData) {
    //     return true
    //   }
    //   if (!this.finalCourseMarkId) {
    //     return true
    //   }
    //   const realSelected = this.tableData
    //     .filter(i => this.selected.find(f => f.student.id === i.student.id))
    //     .filter(
    //       i => !this.shouldCheckCourseQualification || this.studentCourseQualificationStatus[i.id]
    //     )

    //   return !realSelected.some(({ marksObj }) => {
    //     return Object.entries(marksObj).some(([k, v]) => {
    //       return k === this.finalCourseMarkId && v !== undefined && v !== null
    //     })
    //   })
    // },

    renderTextForValues() {
      return {
        bool(v) {
          return v ? 'Có' : 'Không'
        },
        status(v) {
          return v === 'learn_again'
            ? 'Học lại'
            : v === 'test_again'
            ? 'Thi lại'
            : v === 'pass'
            ? 'Qua môn'
            : ''
        },
        rank(v) {
          return v === 'excellent'
            ? 'Xuất sắc'
            : v === 'very_good'
            ? 'Giỏi'
            : v === 'good'
            ? 'Khá'
            : v === 'normal'
            ? 'Trung bình'
            : v === 'bad'
            ? 'Yếu'
            : ''
        }
      }
    },
    finalCourseMarkId() {
      if (!this.finalCourseMark) {
        return
      }

      return this.finalCourseMark.id
    },
    shouldCheckCourseQualification() {
      if (!((this.classData || {}).course_mark_config || {}).requireCondition) {
        return false
      }
      return true
    },
    studentCourseQualificationStatus() {
      console.log('hello')
      if (!((this.classData || {}).course_mark_config || {}).requireCondition) {
        return {}
      }
      if (!this.students) {
        return {}
      }
      return Object.fromEntries(
        this.students.map(i => {
          const qualified = !(this.classData.unqualified_students || []).find(j => j === i.id)
          return [i.id, qualified]
        })
      )
    },
    studentDriveFulfillStatus() {
      if (!this.students) {
        return {}
      }
      return Object.fromEntries(
        this.students.map(i => {
          const fulfilled = !!(this.classData.students_drive_fulfilled || []).find(j => j === i.id)
          return [i.id, fulfilled]
        })
      )
    },
    isMarkTableLocked() {
      if (!this.classData) {
        return true
      }
      return this.classData.markTableLocked
    },
    canSeeMarkSheets() {
      if (!this.classData || !this.user || !this.user.role) {
        return false
      }
      if (
        ['education_manager', 'super_admin'].includes(this.user.role.type) ||
        (this.classData.grading_teachers || []).find(t => t.code === this.user.username)
      ) {
        return true
      }
      return false
    },
    canDeleteAllData() {
      if (!this.classData || !this.user || !this.user.role) {
        return false
      }
      if (['education_manager', 'super_admin'].includes(this.user.role.type)) {
        return true
      }
      return false
    },
    canLock() {
      if (!this.classData || !this.user || !this.user.role) {
        return false
      }
      if (
        !this.isMarkTableLocked &&
        (['education_manager', 'super_admin'].includes(this.user.role.type) ||
          (this.classData.teachers || []).find(t => t.code === this.user.username))
      ) {
        return true
      }
      return false
    },
    canEdit() {
      return this.canLock
    },

    canUnLock() {
      if (!this.classData || !this.user || !this.user.role) {
        return false
      }

      if (
        this.isMarkTableLocked &&
        ['education_manager', 'super_admin'].includes(this.user.role.type)
      ) {
        return true
      }
      return false
    },
    getHeaders() {
      let output = [...this.headers]
      // if (!this.showLearningResult) {
      //   output = output.filter(i => !i.value.startsWith('learningResult'))
      // }
      if (this.role.name !== 'Student') return output
      return output.filter(header => header.value !== 'actions')
    },
    headers() {
      return [
        {
          text: 'STT',
          align: 'left',
          sortable: false,
          value: 'index',
          width: 56
        },
        {
          text: 'Học Sinh',
          align: 'left',
          sortable: false,
          value: 'student'
        },
        {
          text: 'Nhóm lớp',
          align: 'left',
          sortable: false,
          value: 'student.tags'
        },
        ...(this.shouldCheckCourseQualification
          ? [
              {
                text: 'Đủ điền kiện tham gia',
                align: 'left',
                sortable: false,
                value: 'qualification'
              }
            ]
          : []),
        {
          text: 'Đủ file drive',
          align: 'left',
          sortable: false,
          value: 'drive_fulfilled'
        },
        {
          text: 'Nghỉ học',
          align: 'left',
          sortable: false,
          value: 'absentPercentage'
        },
        ..._.get(this.courseMarkConfigData, 'course_marks', [])
          .filter(m => m.type === 'component')
          .sort((a, b) => (a.index || 0) - (b.index || 0))
          .map(m => ({
            text: m.title,
            id: m.id,
            value: `marksObj.${m._id}`,
            multiplier: m.multiplier,
            type: m.type,
            align: 'center'
          })),

        ...(this.finalCourseMarkId
          ? [
              {
                text: this.finalCourseMark.title,
                id: this.finalCourseMark.id,
                value: `marksObj.${this.finalCourseMark._id}`,
                multiplier: this.finalCourseMark.multiplier,
                type: this.finalCourseMark.type,
                align: 'center'
              }
            ]
          : []),
        ...(this.finalCourseMarkId
          ? [
              {
                text: 'Điểm thi lại',
                value: 'retestMark',
                sortable: false,
                align: 'center'
              }
            ]
          : []),
        {
          text: 'TB thành phần',
          value: 'learningResult.componentAverage',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Đủ điều kiện thi cuối môn',
          value: 'learningResult.qualifyForFinalExam',
          sortable: false,
          align: 'center'
        },

        {
          text: 'TB môn học',
          value: 'learningResult.finalAverage',
          sortable: false,
          align: 'center'
        },

        {
          text: 'Trạng thái cuối',
          value: 'learningResult.status',
          sortable: false,
          align: 'center'
        },

        { text: 'Xếp loại', value: 'learningResult.rank', sortable: false, align: 'center' },

        { text: 'Nhận xét', value: 'learningResult.note', sortable: false, align: 'center' },
        ...(this.isMarkTableLocked
          ? []
          : [{ text: 'Hành động', value: 'actions', sortable: false, align: 'center' }])
      ]
    },
    learingResultSlotNames() {
      return this.headers
        .filter(c => c.value.includes('learningResult'))
        .map(c => `item.${c.value}`)
    }
  },
  methods: {
    ...mapActions('classDetail', [
      'saveLearningResults',
      'removeLearningResults',
      'initClass',
      'fetchMarks',
      'fetchLearningResults',
      'updateClass',
      'clearMarkAndLearningResultData',
      'clearMarksAndLearningResults',
      'updateLearningResult'
    ]),
    async onClickRecalculateAll() {
      if (!this.classData) {
        return
      }
      // this.$dialog.confirm({
      //   title: 'Tính lại toàn bộ kết quả học tập',
      //   text: `Hành động này sẽ xóa toàn bộ kết quả học tập của cả lớp và tính lại. Bạn có chắc chắn muốn tiếp tục?`,
      //   okText: 'Có',
      //   cancelText: 'Hủy',
      //   done: (async () => {
      try {
        this.recalculatingAll = true
        await Class.recalculateAll(this.classData.id)
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        this.recalculatingAll = false
        await Promise.all([
          this.fetchMarks({ class: this.classData.id }),
          this.fetchLearningResults({ class: this.classData.id })
        ])
      }
      // }).bind(this)
      // })
    },
    renderTextForFinalMark(studentData) {
      if (!this.finalCourseMarkId) {
        return ''
      }
      const val = (studentData['marksObj'] || {})[this.finalCourseMarkId]
      if (val === undefined || val === null) {
        return ''
      }
      //  if (
      //     (this.shouldCheckCourseQualification &&
      //       !this.studentCourseQualificationStatus[studentData.id]) ||
      //     !this.studentDriveFulfillStatus[studentData.id]
      //   ) {
      //     return 0
      //   }
      //   if (
      //     (studentData.learningResult || {}).qualifyForFinalExam !== undefined &&
      //     !studentData.learningResult.qualifyForFinalExam
      //   ) {
      //     return 0
      //   }
      return val
    },
    // setShowLearningResult(v) {
    //   this.showLearningResult = v
    //   localStorage.setItem('showLearningResult', v.toString())
    // },
    onClickExport() {
      this.exportDialog.isOpen = true
      this.exportDialog.title = 'Xuất dữ liệu ra file Excel'
      this.exportDialog.data = {
        exportAllStudents: true,
        exportLearningResult: true
      }
      this.exportDialog.callback = (() => {
        const data = this.tableData
          .map(({ student, learningResult, absentPercentage, marksObj, id }) => {
            const qualified = !!this.studentCourseQualificationStatus[id]
            if (!qualified && !this.exportDialog.data.exportAllStudents) {
              return
            }
            const driveFulfilled = !!this.studentDriveFulfillStatus[id]
            const courseMarkIdToData = Object.fromEntries(
              this.courseMarkConfigData.course_marks.map(i => [i.id, i])
            )
            const markWithTitle = Object.entries(marksObj).map(([courseMarkId, value], index) => {
              const { title, multiplier } = courseMarkIdToData[courseMarkId]
              return [`${index + 1}.${title}(${multiplier})`, value]
            })
            return {
              'Họ và tên': student.name,
              'Nhóm lớp': student.tags,
              'Đủ điều kiện tham gia': this.renderTextForValues.bool(qualified),
              'Đủ file drive': this.renderTextForValues.bool(driveFulfilled),
              'Tỉ lệ vắng': absentPercentage,
              ...Object.fromEntries(markWithTitle),
              ...(this.exportDialog.data.exportLearningResult && {
                'Điểm TB thành phần': learningResult.componentAverage,
                'Đủ diều kiện thi cuối môn': this.renderTextForValues.bool(
                  learningResult.qualifyForFinalExam
                ),
                'Điểm TB cuối môn': learningResult.finalAverage,
                'Trạng thái cuối': this.renderTextForValues.status(learningResult.status),
                'Xếp loại': this.renderTextForValues.rank(learningResult.rank),
                'Nhận xét': learningResult.note
              })
            }
          })
          .filter(Boolean)
        const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false, origin: 'A1' })
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws)
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        saveAs(blob, `${this.classData.code}_bangdiem_${moment().format('YYYY-MM-DD')}.xlsx`)
      }).bind(this)
    },
    async onQualificationChange(value, student) {
      const studentId = student.id
      if (!this.classData) {
        return
      }
      try {
        const currentUnqualified = this.classData.unqualified_students
        const newValOfUnqualifiedStudents = !value
          ? [...currentUnqualified, studentId]
          : currentUnqualified.filter(i => i !== studentId)
        await this.updateClass({
          id: this.classData.id,
          unqualified_students: newValOfUnqualifiedStudents,
          optimisticUpdate: true
        })
        // await this.calculateLearningResult(student, true)

        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        // this.initClass({ id: this.classData.id })
        await Promise.all([
          this.fetchMarks({ class: this.classData.id }),
          this.fetchLearningResults({ class: this.classData.id })
        ])
      }
    },
    async onFulfillStatusChange(value, student) {
      const studentId = student.id
      try {
        if (!this.classData) {
          return
        }
        const currentFulfilled = this.classData.students_drive_fulfilled
        const newValOfStudentsFulfilled = value
          ? [...currentFulfilled, studentId]
          : currentFulfilled.filter(i => i !== studentId)
        await this.updateClass({
          id: this.classData.id,
          students_drive_fulfilled: newValOfStudentsFulfilled,
          optimisticUpdate: true
        })
        // await this.calculateLearningResult(student, true)
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        // if ((this.classData || {}).id) {
        // await Mark.reCalculateFinalMark({
        //   params: {
        //     class: this.classData.id,
        //     student: studentId
        //   }
        // })
        // this.fetchMarks({ class: this.classData.id })
        // this.initClass({ id: this.classData.id })
        // }
        await Promise.all([
          this.fetchMarks({ class: this.classData.id }),
          this.fetchLearningResults({ class: this.classData.id })
        ])
      }
    },
    async updateLock(lock) {
      if (!this.classData) {
        return
      }
      try {
        await this.updateClass({
          id: this.classData.id,
          markTableLocked: lock,
          optimisticUpdate: true
        })
        this.$alert.success(`${lock ? 'Khóa' : 'Mở khóa'} bảng điểm thành công`)
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        // this.initClass({ id: this.classData.id })
      }
    },
    onClickEditNote(item) {
      this.studentToNote = item
      this.noteDialog = true
    },
    genTableData() {
      if (!this.students) {
        return
      }
      const currentLearningResults = Object.fromEntries(
        _.cloneDeep(this.tableData).map(({ student, learningResult }) => [
          student.id,
          learningResult
        ])
      )
      this.tableData = this.students.map((s, index) => {
        const marks = !this.courseMarkConfigData.course_marks
          ? []
          : this.courseMarkConfigData.course_marks.map(({ id: mid, ...o }) => {
              const markValue =
                this.marks.find(mark => {
                  return mark.student.id === s.id && (mark.courseMark || {}).id === mid
                }) || {}
              const { value } = markValue

              return {
                ...o,
                value: !value ? value : _.round(value, 2),
                id: mid
              }
            })
        const marksObj = Object.fromEntries(
          marks.map(({ id, value }) => {
            return [id, value]
          })
        )
        const currentLearningResult = currentLearningResults[s.id]
        const learningResult =
          this.learningResults.find(ls => ls.student.id === s.id) ||
          (currentLearningResult && !currentLearningResult.id ? currentLearningResult : {}) ||
          {}
        const retestMark = this.retestMarks.find(i => i.student.id === s.id)

        const studentSlots =
          !this.slots || !this.attendances
            ? undefined
            : Object.values(this.slots).map(slot => {
                const studentAttendance = this.attendances[slot.id + s.id] || {}
                const status = studentAttendance.status
                return { ...slot, status }
              })

        return {
          index,
          id: s.id,
          marks,
          marksObj,
          student: s,
          learningResult,
          retestMark: (retestMark || {}).value,
          absentPercentage: !studentSlots ? 0 : calculateAbsentPercentage(studentSlots),
          'row-class': [
            'row-class',
            ...(!this.shouldCheckCourseQualification || this.studentCourseQualificationStatus[s.id]
              ? []
              : ['unqualified-student'])
            // ...((learningResult || {}).qualifyForFinalExam === true ? [] : ['unqualify-final-exam'])
          ]
        }
      })
    },
    onSaveMark() {
      this.calculateLearningResultForAll()
      this.dialog = false
    },
    async calculateLearningResultForAll() {
      const studentsToCalculate = this.tableData.filter(
        i => !this.shouldCheckCourseQualification || this.studentCourseQualificationStatus[i.id]
      )
      try {
        await Promise.all(
          studentsToCalculate.map(async item => {
            await this.calculateLearningResult(item, true)
          })
        )
      } catch (error) {
        console.error(error)
      } finally {
        await Promise.all([
          this.fetchMarks({ class: this.classData.id }),
          this.fetchLearningResults({ class: this.classData.id })
        ])
      }
    },

    // async calculateLearningResult(item, bulkAction = false) {
    //   const marksObj = item.marksObj
    //   const finalMarkValue = !!Object.entries(marksObj).find(
    //     ([k, v]) => k === this.finalCourseMarkId && v !== null && v !== undefined
    //   )
    //   const calculateComponentAverageOnly = !finalMarkValue
    //   const { marks, absentPercentage } = item
    //   if (_.isEmpty(marks)) {
    //     this.$alert.error('Không có điểm thành phần')
    //     return
    //   }
    //   let componentAverage
    //   let qualifyForFinalExam
    //   let finalAverage
    //   let rank
    //   let status

    //   const components = marks
    //     .filter(({ type }) => type === 'component')
    //     .map(({ value, ...o }) => ({ ...o, value: value || 0 }))

    //   try {
    //     if (_.isEmpty(components)) {
    //       this.$alert.error('Không có điểm thành phần')
    //       return
    //     }
    //     componentAverage = round(
    //       _.mean(components.map(({ value, multiplier }) => Array(multiplier).fill(value)).flat()),
    //       1
    //     )

    //     qualifyForFinalExam = componentAverage >= 5 && absentPercentage <= 20

    //     const finalMark = marks
    //       .filter(({ type }) => type === 'final')
    //       .map(({ value, ...o }) => ({ ...o, value: value || 0 }))[0]

    //     if (
    //       !calculateComponentAverageOnly &&
    //       finalMark.value !== undefined &&
    //       finalMark.value !== null
    //     ) {
    //       let { value: finalMarkValue, multiplier: finalMarkMultiplier } = finalMark
    //       if (
    //         (this.shouldCheckCourseQualification &&
    //           !this.studentCourseQualificationStatus[item.id]) ||
    //         !this.studentDriveFulfillStatus[item.id] ||
    //         !qualifyForFinalExam
    //       ) {
    //         finalMarkValue = 0
    //       }
    //       finalAverage = round(
    //         (finalMarkValue * finalMarkMultiplier + componentAverage * (10 - finalMarkMultiplier)) /
    //           10,
    //         1
    //       )
    //       status =
    //         componentAverage < 5 || absentPercentage > 20
    //           ? 'learn_again'
    //           : finalMark && finalMarkValue < 5
    //           ? 'test_again'
    //           : 'pass'

    //       rank =
    //         finalAverage >= 9
    //           ? 'excellent'
    //           : finalAverage >= 8
    //           ? 'very_good'
    //           : finalAverage >= 7
    //           ? 'good'
    //           : finalAverage >= 5
    //           ? 'normal'
    //           : 'bad'
    //     }
    //     try {
    //       // this.tableData =
    //       await Promise.all(
    //         this.tableData.map(async i => {
    //           if (i.student.id !== item.student.id) {
    //             return i
    //           }
    //           const newval = {
    //             ...i,
    //             learningResult: {
    //               ...(i.learningResult || {}),
    //               ...(componentAverage !== undefined && {
    //                 componentAverage
    //               }),
    //               ...(qualifyForFinalExam !== undefined && {
    //                 qualifyForFinalExam
    //               }),
    //               ...(finalAverage !== undefined && {
    //                 finalAverage
    //               }),
    //               ...(rank !== undefined && {
    //                 rank
    //               }),
    //               ...(status !== undefined && {
    //                 status
    //               })
    //             }
    //           }
    //           await this.saveLearningResult(newval)
    //           return newval
    //         })
    //       )
    //       if (!bulkAction) {
    //         this.$alert.success('Lưu kết quả học tập thành công')
    //       }
    //     } catch (error) {
    //       console.error(error)
    //       if (!bulkAction) {
    //         this.$alert.error('Có lỗi xảy ra')
    //       } else {
    //         throw error
    //       }
    //     } finally {
    //       if (!bulkAction) {
    //         this.initClass({ id: this.classData.id })
    //       }
    //     }

    //     // this.setShowLearningResult(true)
    //   } catch (error) {
    //     console.error(error)
    //     this.$alert.error('Lỗi tính toán')
    //   }
    // },
    clearAllData() {
      this.$dialog.confirm({
        title: 'Xóa dữ liệu điểm',
        text: ` Bạn có chắc chắn muốn xóa toàn bộ dữ liệu điểm và kết quả học tập trong bảng này ?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: (async () => {
          if (!this.classData.id) {
            return
          }
          try {
            await this.clearMarkAndLearningResultData(this.classData.id)
            this.$alert.success('Xóa thành công')
          } catch (error) {
            console.error(error)
            this.$alert.error('Có lỗi xảy ra!')
          }
        }).bind(this)
      })
    },
    async removeLearningResultForSelected() {
      // if (!this.showLearningResult) {
      //   this.showLearningResult = true
      // }
      const selected = this.tableData
        .filter(i => this.selected.find(f => f.student.id === i.student.id))
        .filter(
          i => !this.shouldCheckCourseQualification || this.studentCourseQualificationStatus[i.id]
        )

      try {
        await this.removeLearningResults({
          data: selected
            .map(item => {
              const id = (item.learningResult || {}).id
              return id
            })
            .filter(Boolean)
        })

        this.$alert.success('Xóa thành công')
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra!')
      }
    },
    async removeLearningResult(item, bulkAction = false) {
      try {
        const id = (item.learningResult || {}).id
        if (!id) {
          // this.tableData = this.tableData.map(i => {
          //   if (i.id === item.id) {
          //     const { learningResult, ...o } = i
          //     return { ...o, learningResult: {} }
          //   }
          //   return i
          // })
          return
        }
        await this.removeLearningResults({ data: [id] })
        if (!bulkAction) {
          this.$alert.success('Xóa thành công')
        }
      } catch (error) {
        console.error(error)
        if (!bulkAction) {
          this.$alert.error('Có lỗi xảy ra!')
        } else {
          throw error
        }
      } finally {
        // if (!bulkAction) this.initClass({ id: this.classData.id })
      }
    },
    async saveLearningResult(item) {
      if (_.isEmpty(item.learningResult)) {
        this.$alert.error('Sinh viên chưa có kết quả học tập')
        return
      }
      if (
        item.learningResult.componentAverage === undefined &&
        item.learningResult.finalAverage === undefined &&
        !item.learningResult.status &&
        !item.learningResult.rank
      ) {
        // this.$alert.error('Sinh viên thiếu kết quả học tập')
        return
      }
      await this.saveLearningResults({
        data: [item].map(({ student, learningResult }) => ({
          ...learningResult,
          student: student.id,
          class: this.classData.id,
          course_mark_config: this.courseMarkConfigData.id
        }))
      })
    },
    // async saveLearningResultForSelected() {
    //   const selected = this.tableData
    //     .filter(i => this.selected.find(f => f.student.id === i.student.id))
    //     .filter(
    //       i => !this.shouldCheckCourseQualification || this.studentCourseQualificationStatus[i.id]
    //     )
    //   const fail = selected.find(item => _.isEmpty(item.learningResult))
    //   if (fail) {
    //     this.$alert.error(`Sinh viên ${fail.student.name} chưa có kết quả học tập`)
    //     return
    //   }
    //   try {
    //     await this.saveLearningResults({
    //       data: selected.map(({ student, learningResult }) => ({
    //         ...learningResult,
    //         student: student.id,
    //         class: this.classData.id
    //       }))
    //     })
    //     this.$alert.success('Lưu thành công')
    //   } catch (error) {
    //     console.error(error)
    //     this.$alert.error('Có lỗi xảy ra!')
    //   } finally {
    //     this.initClass({ id: this.classData.id })
    //   }
    // },
    onClickEditMark(markId) {
      this.$alert.close()
      this.markId = markId
      this.dialog = true
    },
    async saveNote(note) {
      const learningResultId = (this.studentToNote.learningResult || {}).id
      if (!learningResultId) {
        return
      }
      // this.tableData = this.tableData.map(i => {
      //   if (i.student.id === this.studentToNote.student.id) {
      //     return { ...i, learningResult: { ...i.learningResult, note } }
      //   }
      //   return i
      // })
      try {
        await this.updateLearningResult({ id: learningResultId, note })
        this.$alert.success('Cập nhật thành công')
      } catch (error) {
        console.error(error)
        this.$alert.error('Có lỗi xảy ra')
      }
    },
    closeNoteDialog() {
      this.noteDialog = false
      this.studentToNote = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

::v-deep {
  th,
  td {
    background-color: #fff;
  }
  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  .editable th:nth-child(2),
  .editable td:nth-child(2) {
    position: sticky;
    // left: 56px;
    z-index: 1;
  }
  th:nth-child(2)[rowspan] {
    z-index: 2;
  }
  th:nth-child(1)[rowspan] {
    z-index: 3;
  }
  thead {
    tr {
      height: 64px;
    }
    tr:first-child th {
      position: sticky;
      top: 0;
      z-index: 1;
    }
    tr:nth-child(2) th {
      position: sticky;
      top: 64px;
    }
    th {
      z-index: 1;
    }
  }
  th.learning-result-cell {
    background-color: orange;
    color: black !important;
  }

  .v-data-table__wrapper {
    height: calc(100vh - 210px);
    overflow-x: auto;
    overflow-y: auto;
  }
  .student-note {
    text-transform: unset;
    font-weight: normal;
    cursor: pointer;
    max-width: 120px;
  }
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    .v-data-table__wrapper {
      height: calc(100vh - 230px);
    }
    .student-note {
      max-width: 200px;
    }
  }
  --disabled-color: rgb(231, 231, 231);
  --danger-color: rgb(172, 172, 172);

  .unqualified-student td {
    // background-color: var(--danger-color);
    background-color: var(--disabled-color);
    .v-data-table__checkbox {
      display: none;
    }
  }
  .unqualify-final-exam td {
    background-color: var(--disabled-color);
  }
}
</style>
